import { GroupAttributorTransformRule, GroupByType, GroupFillType, WhenType, ConditionType } from 'src/app/domainObjects/transformers/groupAttributorTransform';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';

export class GroupAttributorRuleViewModel extends TransformRuleViewModel {
  groupFill: GroupFillType;
  groupByValue: string;
  fieldStart: string;
  whenStart: WhenType;
  conditionStart: ConditionType;
  stringStart: string;
  groupByStart: GroupByType;
  fieldEnd: string;
  whenEnd: WhenType;
  conditionEnd: ConditionType;
  stringEnd: string;
  groupByEnd: GroupByType;
  timeout: number;
  include: number;
  run: boolean;

  groupHits?: number;
  rowHits?: number;
  sampleGroupHits?: number;
  sampleRowHits?: number;

  constructor(rule: GroupAttributorTransformRule) {
    super(rule.ruleId, rule.index, rule.run, rule.ruleName);

    this.name = rule.name;
    this.run = rule.run;
    this.groupFill = rule.groupFill;
    this.groupByValue = rule.groupByValue;
    this.fieldStart = rule.fieldStart;
    this.whenStart = rule.whenStart;
    this.conditionStart = rule.conditionStart;
    this.stringStart = rule.stringStart;
    this.groupByStart = rule.groupByStart;
    this.fieldEnd = rule.fieldEnd;
    this.whenEnd = rule.whenEnd;
    this.conditionEnd = rule.conditionEnd;
    this.stringEnd = rule.stringEnd;
    this.groupByEnd = rule.groupByEnd;
    this.timeout = rule.timeout;
    this.run = rule.run;
    this.include = rule.include;
  }

  toGroupAttributorRule(): GroupAttributorTransformRule {
    const rule = new GroupAttributorTransformRule();

    rule.index = this.index - 1;
    rule.ruleName = this.ruleName;
    rule.groupFill = this.groupFill;
    rule.groupByValue = this.groupByValue;
    rule.fieldStart = this.fieldStart;
    rule.whenStart = this.whenStart;
    rule.conditionStart = this.conditionStart;
    rule.stringStart = this.stringStart;
    rule.groupByStart = this.groupByStart;
    rule.fieldEnd = this.fieldEnd;
    rule.whenEnd = this.whenEnd;
    rule.conditionEnd = this.conditionEnd;
    rule.stringEnd = this.stringEnd;
    rule.groupByEnd = this.groupByEnd;
    rule.timeout = this.timeout;
    rule.include = this.include;
    rule.run = this.run;

    return rule;
  }
}